<template>
  <path
    d="M20 2.00024H4C2.9 2.00024 2 2.90024 2 4.00024V22.0002L6 18.0002H20C21.1 18.0002 22 17.1002 22 16.0002V4.00024C22 2.90024 21.1 2.00024 20 2.00024Z"
  />
</template>
